import { useState, useEffect } from 'react';
import { url } from '../utils/config';
import Table from '../reusable_components/Table';
import axios from 'axios';
import { btnOne, btnSmall, btnSmallTwo, btnWhite, label, title } from '../utils/style';
import uiConfigAtom from '../atoms/uiConfigAtom';
import { useRecoilState } from 'recoil';
import formatNumberToUs from '../custom_functions/formatNumberToUs';


function Billing() {
    const [ status, setStatus ] = useState('upcoming')
    const [ uiConfig ] = useRecoilState(uiConfigAtom)

  

    const workOrderOptions = [
        {
            header: 'Work Order Number',
            render: (data) => { return 'WO - ' + data.id}
        },
        {
            header: 'Estimated Amount',
            render: (data) => {
                return `$${formatNumberToUs((data?.totalCost + data?.materialCost)?.toFixed(2))}`
            }
        },
        {
            header: 'Service Type',
            render: data => {
                return data?.booking?.serviceType
            },
            filterKey: 'serviceType'
        },
        {
            header: 'Issue',
            render: data => {
                return data?.booking?.problem
            },
            filterKey: 'problem'
        },
        {
            header: 'Status',
            key: 'status',
        }
    ]

    const invoiceOptions = [
        {
            header: 'Invoice Number',
            render: (data) => {
                return 'INV - ' + data.id
            }
        },
        {
            header: 'Invoice Date',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'Invoice Amount',
            render: (data) => {
                return `$${formatNumberToUs(data.amount?.toFixed(2))}`
            },
            filterKey: 'amount'
        },
        {
            header: 'Customer Name',
            render: data => {
                return data?.user?.firstName + ' ' + data?.user?.lastName
            },
            filterKey: 'name'
        },
        {
            header: 'Status',
            key: 'status',
        },
    ]

    const excludeFilter = ['Work Order Number', 'Estimated Amount', 'Invoice Number', 'Status']

    return(
        <div className="p-4">
            <div className={title}>Billing</div>
            <div className='flex gap-8 py-6 border-b border-customThree'>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${status === 'upcoming' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={status === 'upcoming' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setStatus('upcoming')}>UPCOMING WORK ORDERS</button>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${status === 'paid' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={status === 'paid' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setStatus('paid')}>Completed / Paid Invoices</button>
                <button 
                    className={`text-sm rounded-full py-2 px-8 border border-customOne ${status === 'unpaid' ? 'bg-customOne text-white ' : 'text-customOne'}`}  
                    style={status === 'unpaid' ? {backgroundColor: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex} : {color: uiConfig?.button?.btnBgColor?.hex, borderColor: uiConfig?.button?.btnBgColor?.hex}}
                    onClick={() => setStatus('unpaid')}>Pending / Outstanding Invoices</button>
            </div>

            {
                status === 'upcoming' && 
                <Table 
                    url={url + '/upcoming_work_orders'}
                    options={ workOrderOptions } 
                    pagination
                    noButton
                    excludeFilter={excludeFilter}
                />
            }
            {
                status === 'paid' &&
                <Table 
                    url={url + '/paid_bills'}
                    options={ invoiceOptions } 
                    pagination
                    noButton
                    excludeFilter={excludeFilter}
                />
            }
            {
                status === 'unpaid' &&
                <Table 
                    url={url + '/unpaid_bills'}
                    options={ invoiceOptions } 
                    pagination
                    noButton
                    excludeFilter={excludeFilter}
                />
            }
        </div>
    )
}

export default Billing;